import { createModelSchema, list, identifier, primitive, object, serializable } from 'serializr';
import { observable } from 'mobx';

export default class WorkflowStepTransitionModel {
    @serializable @observable status;
    @serializable @observable reasons;
    @serializable @observable createdOn;

    constructor(status = '', reasons = [], createdOn = '') {
        this.status = observable();
        this.status = status;
        this.reasons = observable(reasons);
        this.createdOn = observable;
        this.createdOn = createdOn;
    }
}



// WEBPACK FOOTER //
// ./src/workflow/workflow-step-transition-model.js